/**
 * Loading Spinner Component
 * Accessible loading indicator
 */

export interface LoadingSpinnerProps {
  /** Spinner size */
  size?: 'sm' | 'md' | 'lg';

  /** Loading text */
  text?: string;

  /** Center in container */
  center?: boolean;
}

export function LoadingSpinner({
  size = 'md',
  text,
  center = false,
}: LoadingSpinnerProps) {
  const sizeStyles = {
    sm: 'ww-h-4 ww-w-4',
    md: 'ww-h-8 ww-w-8',
    lg: 'ww-h-12 ww-w-12',
  };

  const containerStyles = center
    ? 'ww-flex ww-flex-col ww-items-center ww-justify-center ww-min-h-[200px]'
    : 'ww-flex ww-items-center ww-gap-3';

  return (
    <div className={containerStyles} role="status" aria-live="polite">
      <svg
        className={`ww-animate-spin ww-text-primary ${sizeStyles[size]}`}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle
          className="ww-opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="ww-opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      {text && (
        <span className="ww-text-sm ww-text-gray-600">{text}</span>
      )}
      <span className="ww-sr-only">Loading...</span>
    </div>
  );
}
